import { AbstractSceneTransition } from "slotworks/graphics/layers/scene-transitions/abstract-scene-transition";
import Contract from "slotworks/utils/contract";
import settingsModel from "slotworks/model/settings/settings-model";
import gameState from "slotworks/model/game-state";
import { BounceZoomIn, BounceZoomOut } from "slotworks/graphics/animation/base-animations";
import Layers from "slotworks/graphics/layers/layers";
import soundManager from "slotworks/sound/sound-manager";
import { parallel } from "slotworks/utils/race-utils";
import * as TweenJS from "slotworks/utils/tween";
import canvasManager, { Orientation } from "slotworks/graphics/canvas/canvas-manager";
import deviceInfo from "slotworks/utils/device-info";

export default class TotalWinTransitions extends AbstractSceneTransition {
    private BOUNCE_TIME: number = 300;
    private SCALE_MULTIPLIER_X: number = 2;
    private SCALE_MULTIPLIER_Y: number = 1.5;

    private SCALE_MULTIPLIER_X_2: number = 1.6;
    private SCALE_MULTIPLIER_Y_2: number = 1.1;
    private noWinWin: boolean;

    public in(): Contract<void> {
        return new Contract((resolve) => {
            const value = Layers.CelebrationContent.getSprite("value");
            const shine = Layers.CelebrationContent.getSprite("starshine_win_loop");
            this.noWinWin = settingsModel.isUKJurisdiction() && !gameState.getCurrentGame().isWinAboveBet();
            if(this.noWinWin) {
                this.formatLowWinText();
                shine.visible = false;
                resolve(null);
            } else {
                parallel([
                    () => new Contract(resolve => {       
                        const record = gameState.getCurrentGame().getCurrentRecord();
                        const win = record.creditsWon;                 
                        shine.anchor.set(0.5, 0.5);
                        const point = value.position;
                        shine.position.set(point.x, point.y);
                        const widePortrait = canvasManager.orientation == Orientation.PORTRAIT && deviceInfo.widePortrait
                        let multiX = widePortrait ? this.SCALE_MULTIPLIER_X_2 : this.SCALE_MULTIPLIER_X;
                        const multiY = widePortrait ? this.SCALE_MULTIPLIER_Y_2 : this.SCALE_MULTIPLIER_Y;
                        if(win > 9999) {
                            multiX += 0.5;
                        }
                        const scaleX = shine.scale.x * multiX;
                        const scaleY = shine.scale.y * multiY;
                        shine.scale.set(0, 0);
                        new TweenJS.Tween(shine.scale)
                        .to({x: scaleX, y: scaleY}, this.BOUNCE_TIME)
                        .easing(TweenJS.Easing.Back.Out)
                        .onComplete(() => {
                            shine.width = shine.width; // fixes a problem with our implementation of animated sprite
                            shine.height = shine.height;
                            resolve(null);
                        })
                        .start();
                    }),
                    () => BounceZoomIn(value, this.BOUNCE_TIME, 0)]).
                then(resolve);
            }
        });
    }

    public out(): Contract<void> {
        return new Contract((resolve) => {   
            if(this.noWinWin)
                resolve(null);
            else {         
                soundManager.customEvent("tally_collect");
                parallel([
                    () => this.zoomOut(),
                    () => BounceZoomOut(Layers.CelebrationContent.getSprite("value"), this.BOUNCE_TIME, 0)]).
                then(resolve);
            }
        });
    }

    private zoomOut() {
        const shine = Layers.CelebrationContent.getSprite("starshine_win_loop");
        return new Contract(resolve => {
            new TweenJS.Tween(shine.scale)
            .to({x: 0, y: 0}, this.BOUNCE_TIME)
            .easing(TweenJS.Easing.Back.In)
            .onComplete(() => {
                resolve(null);
            })
            .start();
        });
    }

    private formatLowWinText() {
        const text = Layers.CelebrationContent.getSprite("value");
        const scale = text.scale.x * 0.6;
        text.scale.set(scale, scale);
        text.tint = 0xcccccc;
    }
}


// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./src/transitions/total-win-transitions.ts